import { render, staticRenderFns } from "./onMlhf2.vue?vue&type=template&id=619d0aee"
import script from "./onMlhf2.vue?vue&type=script&lang=js"
export * from "./onMlhf2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports